module.exports = __webpack_public_path__ + "static/media/checkBox_unchecked.fd34f152.svg";